import { Container, Row, Col } from 'react-bootstrap';
import { SimpleAncerSmall } from '../../../Components/button';
import {
  HeadingDescSmall,
  HeadingWithSpaceLarge,
  SectionInnerHeading
} from '../../../Components/Headings';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import docImg from '../../../assets/images/png/approveddoc.png';
import './instantConsultant.css';

function InstantConsultant() {
  return (
    <HealthCheckLayout>
      <section className="instantConsultant bgLinghtGray">
        <Container>
          <HeadingWithSpaceLarge text="INSTANT CONSULTATION" />
          <Row>
            <Col md={7} className="order-lg-1 order-2">
              <div className="leftBox">
                <SectionInnerHeading text="Get instant live consultation from thousands of doctors in just under three steps!" />
                <HeadingDescSmall text="Explore our subscription now to get access to live online consultation. " />
                <ol>
                  <li>
                    Prof. Nadia Khurshid Ahmed is a Gynecologist and
                    Obstetrician.
                  </li>
                  <li>
                    Post fellowship experience is 19 years including seven years
                    foreign experience.
                  </li>
                  <li>
                    Prof. Nadia Khurshid is member and examiner of MCPS and FCPS
                    exam.
                  </li>
                </ol>
                <SimpleAncerSmall text="BUY SUBSCRIPTION" to="/" />
              </div>
            </Col>
            <Col md={4} className="order-lg-2 order-1">
              <div className="rightBox">
                <img src={docImg} alt="docImg" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default InstantConsultant;
